import { API_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

let request = () => (axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
}))

class UsuarioNotificacionRequest {
    /**
     * Llamada el endpoint de django para obtener los usuarios
     * que se agregaron para el envió de notificaciones
     * en la BD
     * @param: nada
     * @return: Una lista de notificaciones.
     */
    static ListarUsuarioNotificaciones(filtros) {
        return middleware.hasAuth(() => request().get(`api/usuario/notificaciones/`, {
            params: {
                plaza: filtros.plaza,
                nombre: filtros.nombre
            }
        }))
    }

    /**
     * Llamada el endpoint de django para configurar una notificación
     * @param: value. id de la notificación
     * @param: data. una lista de objetos que contiene datos de la notificación
     * @return: Mensaje de éxito o error.
     */
    static editarNotificacion(value, data){
        if (value === null) {
            return middleware.hasAuth(() => request().post(`api/usuario/notificaciones/`, data));
        }
        else {
            return middleware.hasAuth(() => request().put(`api/usuario/notificaciones/?id=${value}`, data));
        }
    }

    static eliminarNotificacion(value){
        return middleware.hasAuth(() => request().delete(`api/usuario/notificaciones/delete/${value}/`));
    }
}
export default UsuarioNotificacionRequest;